
import { Component, Vue, Prop } from 'vue-property-decorator';

type FilterGATracking = {
  eventCategory: string;
  eventAction: string;
};

@Component({})
export default class UseFilterByTags extends Vue {
  @Prop({ default: () => [] }) initialTags?: string[];

  filteredTags: string[] = this.initialTags || [];

  handleTagClick(
    tagType: string,
    gaTracking?: FilterGATracking,
    multiSelected: boolean = true
  ) {
    let newFilteredTags = multiSelected
      ? [...this.filteredTags, tagType]
      : [tagType];

    const tagIsAlreadySelected = this.filteredTags.includes(tagType);

    if (tagIsAlreadySelected) {
      newFilteredTags = this.filteredTags.filter(tag => tag !== tagType);
    }

    if (gaTracking) {
      this.$analytics({
        ...gaTracking,
        eventLabel: `[${tagIsAlreadySelected ? 'hide' : 'visible'}] ${tagType}`
      });
    }

    this.filteredTags = newFilteredTags;
    this.$emit('filter-change', newFilteredTags);
  }
}
